module.exports = __webpack_public_path__ + "assets/img/0414.30032301.png";